
import { Component, Vue } from "vue-property-decorator";
import ticketAdministration from "@/views/Ticket/indexAdminis.vue";

@Component({
  name: "AllMyOrderLists",
  components: {
    ticketAdministration,
  },
})
export default class extends Vue {}
